module.exports = __webpack_public_path__ + "media/images/image_icon-4e3da6e44d34042bbafd2d21ccea3267.svg";